export default {
  loadingStyles: {
    fontFamily: "Roboto",
    position: "fixed" as "fixed",
    top: "50%",
    left: "50%",
    fontSize: "2rem",
  },
};
